/**
 * Manages the menu selector dropdown in the review form.
 * When a user opens the review modal from a venue page (without menu context),
 * this controller shows a dropdown to select which menu they want to search.
 * Once selected, it reveals the search input and sets the menu ID.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "searchWrapper"];

  /**
   * Handles menu selection from the dropdown.
   * Shows the search input and updates the
   * review-item-search controller.
   */
  selectMenu(event) {
    const menuId = event.target.value;
    if (!menuId) return;

    // Show the search wrapper
    this.searchWrapperTarget.classList.remove("hidden");

    // Find the review-item-search controller
    // and update its menuId
    const searchController =
      this.application
        .getControllerForElementAndIdentifier(
          this.searchWrapperTarget.querySelector(
            "[data-controller='review-item-search']"
          ),
          "review-item-search"
        );

    if (searchController) {
      searchController.setMenuId(menuId);

      // Clear any existing search and results
      const searchInput = searchController.searchInputTarget;
      if (searchInput) {
        searchInput.value = "";
        searchInput.focus();
      }
      searchController.collapseResults();
      const resultsContainer = document.getElementById(
        "review_items_search_results"
      );
      if (resultsContainer) {
        resultsContainer.innerHTML = "";
      }
    }
  }
}
